export const getWidthBlock = device =>
  (device.width ? (device.width * 70) / 100 + 'px' : '254px')
